import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { ButtonType } from '@design-system/components/molecules/button/entities/button.types';

@Component({
  selector: 'app-confirm-delete-alert',
  templateUrl: './confirm-delete-alert.component.html',
  styleUrls: ['./confirm-delete-alert.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ConfirmDeleteAlertComponent {

  @Output()
  public confirmDeleteAlert: EventEmitter<boolean> = new EventEmitter<boolean>();

  private readonly MODAL_WIDTH_MOBILE: number = 343;
  private readonly MODAL_WIDTH_DESKTOP: number = 480;
  public readonly ALERT_NOTIFICATION: string = 'alert.svg';
  public readonly cancelButtonType = ButtonType.Secondary;

  private _isMobile: boolean;
  public modalWidth: number;

  constructor() { }

  public get isMobile(): boolean {
    return this._isMobile;
  }

  @Input()
  public set isMobile(value: boolean) {
    this._isMobile = value;
    this.modalWidth = this.isMobile ? this.MODAL_WIDTH_MOBILE : this.MODAL_WIDTH_DESKTOP;
  }

}
